import fetch from "@/utils/request";


export default {
  getBankCardList(data?: object): any {
    return fetch({
      url: "/php/api/user/bank_list",
      method: "get",
      data
    });
  }
};
